import ManageBookingsBanner from "./ManageBookingsBanner";
export default ManageBookingsBanner;